let $form = $('#profile-form');

let validator = $form.validate({
    rules: {
        last_name: "required",
        name: "required",
        middle_name: "required",
        phone: "required",
        "property[country]": "required",
        "property[postcode]": "required",
        "property[state]": "required",
        "property[city]": "required",
        "property[address]": "required",
    },
    highlight: function (element) {
        $(element).closest('.input-line').addClass('has-error');
    },
    unhighlight: function (element) {
        $(element).closest('.input-line').removeClass('has-error');
    },
    messages: {
        last_name: "Поле обязательно для заполнения",
        name: "Поле обязательно для заполнения",
        middle_name: "Поле обязательно для заполнения",
        phone: "Поле обязательно для заполнения",
        "property[country]": "Поле обязательно для заполнения",
        "property[postcode]": "Поле обязательно для заполнения",
        "property[state]": "Поле обязательно для заполнения",
        "property[city]": "Поле обязательно для заполнения",
        "property[address]": "Поле обязательно для заполнения",
    },
});

$form.on('submit', function(e) {

    if (validator.valid()) {
        e.preventDefault();
        oc.progressBar.show();
        oc.request(this, 'UserPage::onAjax', {
            success: function(response) {
                oc.progressBar.hide();
                if (!response) {
                    return;
                }

                var redirect = (response.$env && response.$env.getRedirectUrl()) || response['X_OCTOBER_REDIRECT']; // jshint ignore:line
                if (redirect) {
                    window.location = redirect;
                    return;
                }

                if (!response.status) {
                    oc.flashMsg({message: response.message, class: 'flash-message-error'});
                }
            }
        });
        return false;
    }

});
